/*
 * Copyright (c) CIRROM 2025.
 */

import React, { JSX } from "react";
import { useLocation } from "react-router-dom";

import { SidebarItemsType } from "../../types/sidebar";
import { reduceChildRoutes } from "./reduceChildRoutes";

type SidebarNavListProps = {
  depth: number;
  pages: SidebarItemsType[];
  isCollapsed?: boolean;
};

const SidebarNavList: React.FC<SidebarNavListProps> = (props) => {
  const { pages, depth, isCollapsed = false } = props;
  const router = useLocation();
  const currentRoute = router.pathname;

  const childRoutes = pages.reduce(
    (items, page) =>
      reduceChildRoutes({ items, page, currentRoute, depth, isCollapsed }),
    [] as JSX.Element[]
  );

  return <React.Fragment>{childRoutes}</React.Fragment>;
};

export default SidebarNavList;
